import { TuiDay } from '@taiga-ui/cdk';

function defaultSort(x, y) {
    const a = x instanceof TuiDay ? Number(x.toUtcNativeDate()) : x;
    const b = y instanceof TuiDay ? Number(y.toUtcNativeDate()) : y;
    if (a === b) {
        return 0;
    }
    if (typeof a === 'string' && typeof b === 'string') {
        return a.localeCompare(b);
    }
    return a > b ? 1 : -1;
}

/**
 * Generated bundle index. Do not edit.
 */

export { defaultSort };

//# sourceMappingURL=taiga-ui-addon-table-utils.js.map